// import { DndContext, closestCenter } from "@dnd-kit/core";
// import {
//   SortableContext,
//   horizontalListSortingStrategy,
//   arrayMove,
// } from "@dnd-kit/sortable";
// import { components } from "react-select";

// export default function SortableValueContainer(props) {
//   const { children, selectProps } = props;

//   const value = selectProps.value || [];
//   const ids = value.map((v) => v.value);

//   return (
//     <DndContext
//       collisionDetection={closestCenter}
//       onDragEnd={(event) => {
//         const { active, over } = event;
//         if (!over || active.id === over.id) return;

//         const oldIndex = ids.indexOf(active.id);
//         const newIndex = ids.indexOf(over.id);

//         const newValue = arrayMove(value, oldIndex, newIndex);
//         selectProps.onChange(newValue);
//       }}
//     >
//       <SortableContext items={ids} strategy={horizontalListSortingStrategy}>
//         <components.ValueContainer {...props}>
//           {children}
//         </components.ValueContainer>
//       </SortableContext>
//     </DndContext>
//   );
// }

// import { DndContext, closestCenter } from "@dnd-kit/core";
// import {
//   SortableContext,
//   horizontalListSortingStrategy,
//   arrayMove,
// } from "@dnd-kit/sortable";
// import { components } from "react-select";

// export default function SortableValueContainer(props) {
//   const { children, selectProps } = props;

//   const value = selectProps?.value || [];
//   const ids = value.map((v) => v?.value);

//   const handleDragEnd = (event) => {
//     const { active, over } = event;
//     if (!over || active?.id === over?.id) return;

//     const oldIndex = ids?.indexOf(active?.id);
//     const newIndex = ids?.indexOf(over?.id);

//     const newValue = arrayMove(value, oldIndex, newIndex);

//     // ✅ IMPORTANT: call original onChange with correct format
//     selectProps.onChange(newValue, {
//       action: "dnd-reorder",
//     });
//   };

//   return (
//     <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
//       <SortableContext items={ids} strategy={horizontalListSortingStrategy}>
//         <components.ValueContainer {...props}>
//           {children}
//         </components.ValueContainer>
//       </SortableContext>
//     </DndContext>
//   );
// }

import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

import {
  SortableContext,
  horizontalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";

import { components } from "react-select";

export default function SortableValueContainer(props) {
  const { children, selectProps } = props;

  const value = selectProps?.value || [];
  const ids = value.map((v) => v?.value);

  // 🔥 IMPORTANT: activation constraint
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8, // drag only starts after 8px movement
      },
    }),
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active?.id === over?.id) return;

    const oldIndex = ids.indexOf(active.id);
    const newIndex = ids.indexOf(over.id);

    const newValue = arrayMove(value, oldIndex, newIndex);

    selectProps.onChange(newValue, {
      action: "dnd-reorder",
    });
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext items={ids} strategy={horizontalListSortingStrategy}>
        <components.ValueContainer {...props}>
          {children}
        </components.ValueContainer>
      </SortableContext>
    </DndContext>
  );
}
